module.exports = __webpack_public_path__ + "static/media/aftershow4JJSlarge.d2336e23.jpg";